import { render, staticRenderFns } from "./GoogleAdsRegister.vue?vue&type=template&id=1a51254e&"
import script from "./GoogleAdsRegister.vue?vue&type=script&lang=js&"
export * from "./GoogleAdsRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports